import { Chip, ChipGroup, Text } from "@/components/ui";
import { BIRTHDAY_MONTHS, clampBirthdayDay, daysInBirthdayMonth } from "@/domain/birthday/calendar";

/** Chosen values as strings; empty while unchosen. */
export type BirthdaySelection = { day: string; month: string };

type BirthdaySelectsProps = BirthdaySelection & {
  onChange: (next: BirthdaySelection) => void;
  disabled?: boolean;
};

/** Inline Mês chips and Dia grid (no year); the grid follows the month, February keeps the 29th, and a day the new month lacks is cleared. */
export function BirthdaySelects({ day, month, onChange, disabled = false }: BirthdaySelectsProps) {
  const dayCount = month ? daysInBirthdayMonth(Number(month)) : 31;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Text as="span" size="sm" weight="semibold">
          Mês
        </Text>
        <ChipGroup
          label="Mês"
          layout="wrap"
          value={month || null}
          onValueChange={(next) => onChange({ day: clampBirthdayDay(day, next), month: next })}
        >
          {BIRTHDAY_MONTHS.map((name, index) => (
            <Chip
              key={name}
              value={String(index + 1)}
              size="sm"
              appearance="soft"
              disabled={disabled}
              aria-label={name}
            >
              {name.slice(0, 3)}
            </Chip>
          ))}
        </ChipGroup>
      </div>
      <div className="flex flex-col gap-2">
        <Text as="span" size="sm" weight="semibold">
          Dia
        </Text>
        <ChipGroup
          label="Dia"
          layout="wrap"
          className="grid grid-cols-7 gap-1.5"
          value={day || null}
          onValueChange={(next) => onChange({ day: next, month })}
        >
          {Array.from({ length: dayCount }, (_, index) => String(index + 1)).map((value) => (
            <Chip
              key={value}
              value={value}
              size="sm"
              appearance="soft"
              disabled={disabled}
              className="w-full justify-center"
            >
              {value}
            </Chip>
          ))}
        </ChipGroup>
      </div>
    </div>
  );
}
